import {
  Box,
  Divider,
  Stack,
  Typography,
} from '@mui/material';
import { CARD_SX, SECTION_ICON_BOX_SX } from './accountOverview.utils';

export default function AccountOverviewSummaryCard({ title, icon, children }) {
  return (
    <Box sx={{ ...CARD_SX, p: { xs: 2.75, md: 3 } }}>
      <Stack direction="row" alignItems="center" gap={1.25} sx={{ mb: 1.5 }}>
        {icon && <Box sx={SECTION_ICON_BOX_SX}>{icon}</Box>}
        <Typography
          variant="overline"
          sx={{
            color: '#64748b',
            letterSpacing: '0.16em',
            fontWeight: 700,
            fontSize: '0.7rem',
            lineHeight: 1,
          }}
        >
          {title}
        </Typography>
      </Stack>
      <Divider sx={{ mb: 2, borderColor: 'rgba(15, 23, 42, 0.06)' }} />
      {children}
    </Box>
  );
}
